<div class="modal inmodal fade in parcel-modal parcel-history-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">History of Key Log: {{keyTag}}</h4>
            </div>
            <div class="modal-body">
                <div class="timeline">
                    <spinner [spinnerShow]="showSpinner"></spinner>
                    <div *ngIf="activities.length > 0">
                        <ul class="timeline__list no-bottom-gap">
                            <li *ngFor="let a of activities">
                                <section>
                                    <header class="timeline__header">
                                        <span>
                                            <time>{{ a.createdAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.createdBy ? a.createdBy.fullName : '' }}
                                        </span>
                                    </header>

                                    <main class="timeline__content">
                                        <div>
                                            {{ a.status == 'signet_out' ? 'Issued to' :'Returned by'}}
                                            <span class="timeline__active">{{a.user ? a.user.fullName : 'N/A'}}</span>
                                            <!--Signature-->
                                            <div class="signatureImage m-t-md" *ngIf="a.signUrl">
                                                <img [src]="a.signUrl">
                                            </div>
                                        </div>
                                        <div *ngIf="a.activityNotes" class="activity-notes">{{a.activityNotes}}</div>
                                    </main>
                                </section>
                            </li>
                        </ul>
                    </div>
                    <div *ngIf="!activities.length && !showSpinner" class="no-history">
                        There are no history records about this Key Log
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log-history/key-log-history.component.html